import React, { useState } from 'react';

/**
 * Ролик личного кабинета (lovestoria.org/preview/cabinet) в iframe — для
 * блока «как готовится книга» на лендингах. На узком экране (до 760px)
 * мобильная вёрстка в корпусе телефона, кадр 3:4; иначе веб в квадрате.
 * Адрес выбирается один раз при монтировании, поэтому iframe один и
 * кабинет грузится один раз.
 */
export type CabinetPreviewLang = 'ru' | 'ru-ru' | 'tr' | 'en';

const ORIGIN = process.env.REACT_APP_CABINET_PREVIEW_ORIGIN || 'https://lovestoria.org';
const PHONE_QUERY = '(max-width: 760px)';

/** Ролик под язык страницы: турецкий и английский свои, остальные — русский (Казахстан). */
export const cabinetPreviewLangForPage = (pageLang?: string | null): CabinetPreviewLang => {
  const l = (pageLang || '').toLowerCase().split('-')[0];
  return l === 'tr' || l === 'en' ? l : 'ru';
};

export function CabinetPreviewFrame({
  scenario,
  lang,
  title,
}: {
  scenario: 'answers' | 'cover';
  /** Рынок ролика: ru — Казахстан, ru-ru — Россия и Беларусь, tr, en — Запад. */
  lang: CabinetPreviewLang;
  title: string;
}) {
  const [phone] = useState(
    () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(PHONE_QUERY).matches,
  );
  const src = `${ORIGIN}/preview/cabinet?scenario=${scenario}&lang=${lang}&embed=1${phone ? '&device=phone' : ''}`;
  return <iframe className="lp-how__cabinet" title={title} src={src} loading="lazy" />;
}
